export default function (window) {
  function isAvailable(name) {
    try {
      const unique = `testStorage${Date.now()}`
      const st = window[name]
      st.setItem(unique, unique)
      const value = st.getItem(unique)
      st.removeItem(unique)
      if (value !== unique) {
        throw 'not equal' //eslint-disable-line no-throw-literal
      }
    } catch (e) {
      return false
    }
    return true
  }

  let storage
  if (isAvailable('localStorage')) {
    storage = window.localStorage
  } else if (isAvailable('sessionStorage')) {
    storage = window.sessionStorage
  } else {
    storage = {
      setItem() {},
      getItem() {},
      removeItem() {}
    }
  }

  return {
    save(key, value) {
      storage.setItem(key, value)
    },
    load(key) {
      return storage.getItem(key)
    },
    remove(key) {
      storage.removeItem(key)
    }
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/storageUtil.js